import React, { memo, useContext } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { CustomInput } from "components";
import RadioButton from "components/radioButton";
import { float6Normalizer } from "validators";
import {
	applyValidatorsIf,
	floatToSixValidation,
	maxValue100,
	onlyPercentToSixFloat,
} from "validators/validation";

import FeesTemplateContext from "../../feesTemplateContext";

import styles from "./tabsChoose.module.scss";

const InterchangePlus = ({ setCurrentValueInField, isPaperApplication }) => {
	const { isFiservFspProcessor } = useContext(FeesTemplateContext);
	const handleInterchangePlusTemplate = (_e, newValue, _previousValue) => {
		setCurrentValueInField(true);
	};
	return (
		<div>
			<div className={styles.subHeader}>Interchange Plus</div>
			<Row>
				<Col md={5}>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(value, allValues) =>
								allValues.feeProgram === "InterchangePlus",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Interchange+ V/MC/D, %"
						name="interchangePlusVMCD"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleInterchangePlusTemplate}
						hideRequiredMark={isPaperApplication}
					/>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(value, allValues) =>
								allValues.feeProgram === "InterchangePlus",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Interchange+ Offline Debit, %"
						name="interchangePlusOfflineDebit"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleInterchangePlusTemplate}
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
				<Col md={{ span: 5, offset: 2 }}>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(value, allValues) =>
								allValues.feeProgram === "InterchangePlus",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Interchange+ Amex, % "
						name="interchangePlusAmex"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleInterchangePlusTemplate}
						hideRequiredMark={isPaperApplication}
					/>
					{isFiservFspProcessor && (
						<Field
							component={CustomInput}
							normalizeOnBlur={float6Normalizer}
							validate={applyValidatorsIf(
								(value, allValues) =>
									allValues.feeProgram === "InterchangePlus",
							)([maxValue100])}
							normalize={onlyPercentToSixFloat}
							label="Commercial Card Interchange Service Fee, %"
							name="commercialCardInterchangeServiceFee"
							placeholder="0.000000"
							placeholderClassName={
								isPaperApplication
									? "placeholder-value"
									: "placeholder-primary"
							}
							onChange={handleInterchangePlusTemplate}
							hideRequiredMark={isPaperApplication}
						/>
					)}
				</Col>
			</Row>
			<div className={styles.addressTitle}>Pass Card Brand Fees</div>
			<Row>
				<Col md={12}>
					<div className="d-flex">
						<Field
							component={RadioButton}
							value="true"
							className={styles.radioButton}
							name="passCardBrandFees"
							label="Yes"
							type="radio"
							id="yesPassDues"
						/>
						<Field
							component={RadioButton}
							value="false"
							className={styles.radioButton}
							name="passCardBrandFees"
							label="No"
							type="radio"
							id="noPassDues"
						/>
					</div>
				</Col>
			</Row>
			<div className={styles.addressTitle}>Gross / Net</div>
			<Row>
				<Col md={12}>
					<div className="d-flex">
						<Field
							component={RadioButton}
							value="0"
							className={styles.radioButton}
							name="interchangePlusRevenueType"
							label="Gross"
							type="radio"
							id="revenueTypeGross"
						/>
						<Field
							component={RadioButton}
							value="1"
							className={styles.radioButton}
							name="interchangePlusRevenueType"
							label="Net"
							type="radio"
							id="revenueTypeNet"
						/>
					</div>
				</Col>
			</Row>
		</div>
	);
};

export default memo(InterchangePlus);
